import { TollFreeVerificationStatusResponseSchema } from "@redotech/redo-common-model/phone/phone-number";
import * as z from "zod";

export const getTollFreeVerificationStatus = {
  name: "getTollFreeVerificationStatus" as const,
  input: z.object({ phoneNumber: z.string() }),
  output: TollFreeVerificationStatusResponseSchema,
};
